/**
 * Created by gusenlin on 2017/10/27.
 * 用来调用审批流相应接口
 */
import { fetch } from 'utils/fetch';

class ExpenseReportService {
  constructor() {
    return this;
  }

  //导入费用到报销单
  importExpense(data) {
    return fetch({
      url: '/api/expense/report/invoices/import',
      method: 'POST',
      data: data,
    });
  }

  importApplicationBudgets(data) {
    return fetch({
      url: '/api/expense/report/application/budgets/import',
      method: 'POST',
      data,
    });
  }

  // 获取表单配置属性
  getFormConfig(formId) {
    return fetch({
      url: `/api/applications/propertyList/${formId}`,
      method: 'GET',
    });
  }

  ExpenseReportTypesQuery() {
    return fetch({
      url: '/api/custom/forms/my/available?formType=102',
      method: 'GET',
    });
  }

  expenseReportListQuery(params) {
    let data = {};
    Object.keys(params)
      .filter((item) => !!params[item])
      .forEach((item) => {
        data[item] = params[item];
      });
    return fetch({
      url: '/api/expense/reports/my',
      method: 'GET',
      params: data,
    });
  }

  // 删除报销单
  deleteExpenseReport(expenseReportOID, deleteInvoiceType) {
    return fetch({
      url: '/api/expense/reports/' + expenseReportOID,
      method: 'DELETE',
      params: { deleteInvoiceType },
    });
  }

  // 撤回报销单
  backExpenseReport(data) {
    return fetch({
      url: '/api/approvals/withdraw',
      method: 'POST',
      data: data,
    });
  }

  expenseReportQuery(expenseReportOID) {
    return fetch({
      url: '/api/expense/reports/' + expenseReportOID,
      method: 'GET',
    });
  }

  //获取报销单上的费用信息
  fetchInvoices(data) {
    return fetch({
      url: '/api/invoices/batch',
      method: 'POST',
      data: data,
    });
  }

  withdrawExpenseReport(data) {
    return fetch({
      url: '/api/approvals/withdraw',
      method: 'POST',
      data: data,
    });
  }

  saveExpenseReport(data) {
    return fetch({
      url: '/api/expense/reports/custom/form/draft',
      method: 'POST',
      data: { ...data, isDateCombinedUTC: false, showValidatePopUp: true },
      timeout: 60000,
    });
  }

  submitExpenseReport(data) {
    return fetch({
      url: '/api/v3/expense/report/submit',
      method: 'POST',
      timeout: 120 * 1000,
      data: data,
    });
  }

  standardCheckout(data) {
    return fetch({
      url: '/api/travel/standards/validate',
      method: 'POST',
      data: data,
    });
  }

  saveCustomForm(data) {
    return fetch({
      url: '/api/expense/reports/custom/form/draft',
      method: 'POST',
      data: { ...data, isDateCombinedUTC: false, showValidatePopUp: true },
    });
  }

  saveAccountCustomForm(data, invoiceOIDs) {
    return fetch({
      url: '/api/expense/reports/go/apply/reimbursement',
      method: 'POST',
      data: {
        expenseReportDTO: { ...data, isDateCombinedUTC: false },
        invoiceOIDs,
        showValidatePopUp: true,
        ignoreBudgetWarningFlag: !!data.ignoreBudgetWarningFlag,
      },
    });
  }

  getTotalAmount(url, data) {
    return fetch({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  getCheckStandardResult(data) {
    return fetch({
      url: '/api/travel/standard/results',
      method: 'POST',
      data: data,
    });
  }

  //发票验证
  checkoutInvoiceTrueTest(data) {
    return fetch({
      url: '/receipt/api/receipt/verify',
      method: 'POST',
      data: data,
    });
  }

  fetchApplication(formOID, applicationPage) {
    return fetch({
      url: '/api/applications/passed/my?formOID=' + formOID + '&size=' + 20 + '&page=' + applicationPage,
      method: 'GET',
    });
  }

  fetchCustomForm(formOID) {
    return fetch({
      url: '/api/custom/forms/' + formOID,
      method: 'GET',
    });
  }

  generatePDF(expenseReportOID) {
    return fetch({
      url: '/api/expense/reports/generate/pdf/' + expenseReportOID,
      method: 'GET',
    });
  }

  //是否有还款
  writeOffArtificial(userOID) {
    return fetch({
      url: '/api/repayment/writeoffArtificial/my?applicantOID=' + userOID,
      method: 'GET',
      nativeResponseSerializer: 'number',
    });
  }

  //是否有还款
  hasLoanApplication(userOID) {
    return fetch({
      url: '/api/repayment/writeoffArtificial/my?applicantOID=' + userOID,
      method: 'GET',
      nativeResponseSerializer: 'number',
    });
  }

  fetchInvoiceHeaderList() {
    return fetch({
      url: '/api/invoice/header/list',
      method: 'GET',
    });
  }

  getDefaultCostCenter(userOID, costCenterOID) {
    return fetch({
      url: '/api/bills/default/cost/center/item?applicantOID=' + userOID + '&costCenterOID=' + costCenterOID,
      method: 'GET',
    });
  }

  getDefaultCostCenterItem(costCenterItemOID) {
    return fetch({
      url: '/api/cost/center/item/' + costCenterItemOID,
      method: 'GET',
    });
  }

  getDefaultCorporation(corporationOID) {
    return fetch({
      url: '/api/my/company/receipted/invoice/' + corporationOID,
      method: 'GET',
    });
  }

  getDefaultBankNumber(userOID) {
    return fetch({
      url: '/api/contact/bank/account/enable?page=0&size=20&userOID=' + userOID,
      method: 'GET',
    });
  }

  getDefaultDepartment(departmentOID) {
    return fetch({
      url: '/api/departments/' + departmentOID,
      method: 'GET',
    });
  }

  getDefaultCorporation(corporationOID) {
    return fetch({
      url: '/api/my/company/receipted/invoice/' + corporationOID,
      method: 'GET',
    });
  }

  getDefaultCorporation(corporationOID) {
    return fetch({
      url: '/api/my/company/receipted/invoice/' + corporationOID,
      method: 'GET',
    });
  }

  fetchApprover(userOIDs) {
    return fetch({
      url: '/api/users/oids?userOIDs=' + userOIDs,
      method: 'GET',
    });
  }

  getReceiptDetail(params) {
    return fetch({
      url: '/api/receipt/type/customFrom',
      method: 'GET',
      params,
    });
  }

  /*
   * v3获取报销单详情
   * @param {*} expenseReportOid 报销单OID
   */
  getExpenseClaim(expenseReportOid, sceneCode = 'edit') {
    return fetch({
      url: `/api/v3/expense/reports/${expenseReportOid}`,
      method: 'GET',
      params: { isDateCombinedUTC: false, sceneCode },
    });
  }

  /**
   * 获取报销单费用列表
   * @param expenseReportOid
   * @returns {*}
   */
  getExpenseList(expenseReportOid, searchReceipt) {
    return fetch({
      url: '/api/expense/report/invoices',
      method: 'GET',
      params: {
        expenseReportOID: expenseReportOid,
        isDateCombinedUTC: false,
        searchReceipt: searchReceipt ?? true,
      },
    });
  }

  /**
   * 获取报销单费用分摊列表
   * @param expenseReportOID
   * @param isPermissionFilter 是否需要权限过滤
   * @param approverOID 审批人OID，待审批时需要传当前审批人
   * @returns {*}
   */
  getApportionList(expenseReportOID, isPermissionFilter = false, approverOID) {
    return fetch({
      url: '/api/expense/apportionment/sharing/model/summary',
      method: 'GET',
      params: {
        expenseReportOID,
        isPermissionFilter,
        approverOID,
      },
    });
  }

  /**
   * 获取报销单审批信息
   * @param expenseReportOid
   * @returns {*}
   */
  getWorkflowHistoryData(expenseReportOid) {
    return fetch({
      url: '/api/v2/expense/reports/approval/history',
      method: 'GET',
      params: {
        expenseReportOID: expenseReportOid,
      },
    });
  }

  getDynamicUrl(url) {
    return fetch({
      url: url,
      method: 'GET',
    });
  }

  //收款方列表
  getPayeeList(params) {
    return fetch({
      url: '/api/users/v3/search',
      method: 'GET',
      params: params,
    });
  }

  getPayeeListV2(params) {
    return fetch({
      url: '/api/users/v3/search',
      method: 'GET',
      params: params,
    });
  }

  //
  getUserOID(userOID) {
    return fetch({
      url: '/api/users/oid/' + userOID,
      method: 'GET',
    });
  }
  EFSelectUserV2(params) {
    return fetch({
      url: '/api/expense/report/yingfu/select/user/v2',
      method: 'POST',
      data: params,
    });
  }
  EFSelectUser(params) {
    return fetch({
      url: '/api/expense/report/yingfu/select/user',
      method: 'POST',
      data: params,
    });
  }

  /**
   * 获取单据能关联的申请单
   * @param page
   * @param size
   * @param formOID
   * @param userOID
   * @param keyword
   * @param roleType
   * @returns {*}
   */
  getRelateApplication(params, roleType = 'TENANT') {
    return fetch({
      url: '/api/applications/passed/search',
      method: 'GET',
      params: {
        ...params,
        roleType,
      },
    });
  }

  /**
   * 通过费用报销单OID 获取其关联的费用
   */
  getInvoicesByExpenseReportOID(expenseReportOID) {
    return fetch({
      url: `/api/expense/reports/${expenseReportOID}/expense`,
      method: 'GET',
    });
  }

  /**
   * 获取报销单详情
   * @param expenseReportOID
   * @param roleType
   * @returns {*}
   */
  getExpenseReportDetail(expenseReportOID, roleType = 'TENANT') {
    return fetch({
      url: `/api/v2/expenses/${expenseReportOID}`,
      method: 'GET',
      params: {
        roleType,
        isDateCombinedUTC: false,
      },
    });
  }

  /**
   * 获取用户的借款金额及条数
   * @param {String} applicantOID  用户OID，不传默认当前登录用户
   * @param {String} statusList 获取的单据状态，不传默认取待还款总金额
   * @param {String} currencyCode 金额币种
   */
  getPersonalWriteOffInfo({ applicantOID = '', statusList = '', currencyCode = '' } = {}) {
    return fetch({
      url: '/api/loanBill/my/count',
      method: 'GET',
      params: {
        applicantOID,
        statusList,
        currencyCode,
      },
    });
  }

  // 关联申请单获取代入值
  getApplicationFormData(applicationOIDs, query) {
    return fetch({
      url: '/api/expense/report/application/value',
      method: 'POST',
      data: applicationOIDs,
      params: query,
    });
  }

  // 关联合同获取代入值
  getContractFormData(params) {
    return fetch({
      url: '/api/contract/custom/value/import/available',
      method: 'POST',
      data: params,
    });
  }

  // 获取个人报销单数量统计
  getExpenseClaimTotal(params) {
    let data = {};
    Object.keys(params)
      .filter((item) => !!params[item])
      .forEach((item) => {
        data[item] = params[item];
      });
    return fetch({
      url: '/api/expense/report/stats/type/get',
      method: 'GET',
      params: data,
    });
  }

  // 获取报销单表单信息
  getFormDetail(expenseReportOID, applicantOID, sceneCode, isUseDocumentApplicant) {
    return fetch({
      url: `/api/expense/report/${expenseReportOID}/form`,
      method: 'GET',
      params: {
        userOID: applicantOID ?? null,
        sceneCode,
        isUseDocumentApplicant: isUseDocumentApplicant ?? false,
      },
    });
  }
  //获取复制报销单信息
  getCopyInvoice(data, page = 0, size = 10) {
    return fetch({
      url: `/api/expense/reports/copy/invoice/available?page=${page}&size=${size}`,
      method: 'POST',
      data,
    });
  }

  // 是否可异步提交报销单
  isEnableAsyncSubmit(expenseReportOID) {
    return fetch({
      url: '/api/expense/report/async/submit/check',
      method: 'GET',
      params: {
        expenseReportOID,
      },
      nativeResponseSerializer: 'boolean',
    });
  }

  destroy() {
    this.stop();
  }

  // 获取报销单修改历史
  getChangeHistory(approvalHistoryId) {
    return fetch({
      url: '/api/expense/reports/operation/history',
      method: 'GET',
      params: {
        approvalHistoryId,
      },
    });
  }

  getWrongList(approvalHistoryId, operationDetail) {
    return fetch({
      url: '/api/paymentTransactionDetail/findTransactionDetailMsgByHistoryId',
      method: 'GET',
      params: {
        approvalHistoryId,
        operationDetail,
      },
    });
  }

  getParticipantDetails(data) {
    return fetch({
      url: '/api/v2/users/oids?withCustomValues=true&roleType=TENANT',
      method: 'POST',
      data: data,
    });
  }

  //获取外部信息
  getExpenseThirdInfo(expenseReportOID) {
    return fetch({
      url: '/api/expense/report/third/info',
      method: 'GET',
      params: {
        expenseReportOID,
      },
    });
  }

  // 获取行程信息
  getItineraryList(params) {
    return fetch({
      url: '/api/expense/report/itinerary',
      method: 'GET',
      params,
    });
  }

  returnToNode(params) {
    let url = '/api/approvals/go/back';
    return fetch({
      url: url,
      method: 'POST',
      data: params,
    });
  }

  // 提交报销单前检查核定金额
  checkDiscountAmount(expenseReportOID) {
    return fetch({
      url: '/api/expense/report/submit/invoice/discount/check',
      method: 'GET',
      params: { expenseReportOID },
    });
  }

  // 提交报销单时保存核定金额
  submitDiscountAmount(expenseReportOID, data) {
    return fetch({
      url: `/api/expense/report/invoice/discount?expenseReportOID=${expenseReportOID}`,
      method: 'POST',
      data,
    });
  }

  // 获取费用超标信息
  getInvoiceExcessRecord(oid, operation, isRecordByReport) {
    let url = `/api/invoice/excess/record?expenseReportOid=${oid}&operation=${operation}`;
    isRecordByReport && (url = `/api/expense/report/exceed/standard?expenseReportOID=${oid}&operation=${operation}`);
    operation === '2001' && (url = `/api/expense/report/exceed/standard/all?expenseReportOID=${oid}`);
    return fetch({
      url,
      method: 'GET',
    });
  }

  saveInvoiceExcessReason(data, isRecordByReport) {
    let url = '/api/invoice/excess/record';
    isRecordByReport && (url = '/api/expense/report/exceed/standard');
    return fetch({
      url,
      method: 'POST',
      data: isRecordByReport ? data[0] : data,
      nativeResponseSerializer: 'boolean',
    });
  }

  // 获取显示模式配置
  getExpenseModeConfig(params) {
    return fetch({
      url: '/api/expense/report/show/config',
      method: 'get',
      params,
    });
  }

  getExpenseReportSetting(params) {
    return fetch({
      url: '/api/expense/report/control/setting/company',
      method: 'get',
      params,
    });
  }
  //批量删除费用
  deleteBatchExpense(expenseReportOID, data) {
    return fetch({
      url: `/api/expense/reports/delete/invoice/batch/${expenseReportOID}`,
      method: 'post',
      data,
    });
  }
  //批量退回账本
  backBatchExpense(expenseReportOID, data) {
    return fetch({
      url: `/api/expense/reports/remove/invoice/batch/${expenseReportOID}`,
      method: 'post',
      data,
    });
  }

  getPayLine(params) {
    let data = {};
    Object.keys(params)
      .filter((item) => !!params[item])
      .forEach((item) => {
        data[item] = params[item];
      });
    return fetch({
      url: '/api/payment/schedule/my',
      method: 'get',
      params: data,
    });
  }

  getPayTotal(params) {
    let data = {};
    Object.keys(params)
      .filter((item) => !!params[item])
      .forEach((item) => {
        data[item] = params[item];
      });
    return fetch({
      url: '/api/payment/schedule/my/count',
      method: 'get',
      params: data,
    });
  }

  getLineAccount(paymentScheduleId) {
    return fetch({
      url: `/api/payment/schedule/associate/invoice?paymentScheduleId=${paymentScheduleId}`,
      method: 'get',
    });
  }
  /*
  校验原单据岗位和表单类型是否有可见权限接口
   */
  getCopyVerify(expenseReportOID) {
    return fetch({
      url: `/api/expense/reports/copy/check/job/form?expenseReportOID=${expenseReportOID}`,
      method: 'get',
    });
  }
  /*
  校验原单据表单和选择的新表单oid是否同一账套接口
   */
  getCopyVerifySetBookId(expenseReportOID, formOID) {
    return fetch({
      url: `/api/expense/reports/copy/check/form/setofbooks?expenseReportOID=${expenseReportOID}&formOID=${formOID}`,
      method: 'get',
      nativeResponseSerializer: 'boolean',
    });
  }

  /**
   * 根据费用推荐报销单列表
   */
  getRecommendDocumentList(params) {
    return fetch({
      url: 'api/expense/reports/suggested/by/invoices',
      method: 'POST',
      data: params,
    });
  }

  /**
   * 复制报销单控件带入
   */
  copyFormValue(recommendExpenseOID, userOID, formOID, jobId) {
    return fetch({
      url: '/api/expense/reports/copy/form/value',
      method: 'GET',
      params: {
        expenseReportOID: recommendExpenseOID,
        userOID,
        formOID,
        jobId,
      },
    });
  }

  /**
   * 费用引用表单控件值
   */
  getExpenseTypeCustomValues(invoiceOID, userOID, expenseTypeId, sceneCode) {
    return fetch({
      url: `/invoice/api/expense/form/field/values/${invoiceOID}?userOID=${userOID}&expenseTypeId=${expenseTypeId}&sceneCode=${sceneCode}`,
      method: 'GET',
    });
  }

  // 异步审核系统退回原因
  getAsyncAuditFailedReason(id) {
    return fetch({
      url: `/api/async/audit/failed/reason?approvalHistoryId=${id}`,
      method: 'GET',
    });
  }

  getAutoSubsidy(params) {
    return fetch({
      url: '/api/expense/report/auto/subsidy/expense',
      method: 'POST',
      data: params,
    });
  }

  // 近期报销汇总
  getRecentReportSummary(params) {
    return fetch({
      url: '/api/expense/report/ai/recent/summary',
      method: 'GET',
      params,
    });
  }

  // 其他消费商费用报销情况
  getConsumerReportSummary(params) {
    return fetch({
      url: '/api/expense/report/ai/other/consumer/invoice/condition',
      method: 'GET',
      params,
    });
  }

  // 获取报销单的参与人+申请人
  getExpenseReportParticipants(expenseReportOID) {
    return fetch({
      url: '/api/expense/report/participant/search',
      method: 'GET',
      params: { expenseReportOID },
    });
  }

  // 员工近期报销汇总
  getEmployeeReportSummary(params) {
    return fetch({
      url: '/api/expense/report/ai/employee/recent/summary',
      method: 'GET',
      params,
    });
  }

  // 员工历史同类型费用报销概览
  getEmployeeInvoiceSummary(params) {
    return fetch({
      url: '/api/expense/report/ai/employee/history/same/type/invoice/condition',
      method: 'GET',
      params,
    });
  }

  // 删除单据查询费用检查提示
  getCheckInvoiceTips(expenseReportOID) {
    return fetch({
      url: '/api/expense/report/delete/check/invoice',
      method: 'GET',
      params: { expenseReportOID },
    });
  }

  // 查询额度使用情况
  getQuotaUsedDetail(params) {
    return fetch({
      url: '/api/employee/quota/usecase',
      method: 'GET',
      params,
    });
  }

  // 更新收款信息
  updatePaymentSchedule(params) {
    return fetch({
      url: '/api/payment/schedule/update',
      method: 'put',
      data: params,
    });
  }
}

export default new ExpenseReportService();
